<template>
  <div>
    <avue-crud :option="taskTableOption" :data="taskTableData" :search.sync="searchForm" :page.sync="page"
               @search-change="searchChange"
               ref="crud" @refresh-change="refreshChange" @size-change="sizeChange" @current-change="currentChange"
               highlight-current>
      <template slot="nickName" slot-scope="scope">
        <span>{{ scope.row.trId==='AI打标'?'AI打标':scope.row.nickName }}</span>
      </template>
      <template slot="phone" slot-scope="scope">
        <span>{{ scope.row.trId==='AI打标'?'AI打标':scope.row.phone }}</span>
      </template>

      <template slot="receiveTime" slot-scope="scope">
        <span>{{ scope.row.trId==='AI打标'?formatDate(scope.row.submitTime):formatDate(scope.row.receiveTime) }}</span>
      </template>

      <template slot-scope="scope" slot="status">
        <span>{{ $taskStatus.get(scope.row.status) }}</span>
      </template>

      <template slot-scope="scope" slot="taskType">
        <span>{{ $actionType.get(scope.row.taskType) }}</span>
      </template>

      <template slot-scope="scope" slot="amount">
        <el-badge v-if="scope.row.status===1 && scope.row.addAmount" :value="'+'+scope.row.addAmount" class="item">
          <span style="padding-right: 5px">{{ scope.row.amount }}</span>
        </el-badge>
        <span v-else>{{ scope.row.amount }}</span>
      </template>

      <template slot-scope="{row,index}" slot="menu">
        <el-button type="success"
                   icon="el-icon-document" size="mini" plain @click.stop="viewDetail(row,index)">查看详情
        </el-button>
        <el-button type="primary" v-if="row.status === 1 && permissions.dot_repush" style="margin-left: 0;"
                   icon="el-icon-sort" size="mini" plain @click.stop="rePushSingle(row)">重新推送
        </el-button>
      </template>

    </avue-crud>

    <el-drawer
      title="打标详情"
      :visible.sync="drawer"
      direction="ltr"
      size="75%"
      :before-close="handleClose">
      <el-badge v-if="drawerAddAmt && drawerStatus === 1" :value="'+' + drawerAddAmt" class="item">
        <p class="note" style="padding-right: 5px">任务金额: ￥{{ this.drawerAmt }}</p>
      </el-badge>
      <p class="note" v-else>任务金额: ￥{{ this.drawerAmt }}</p>
      <avue-crud :option="taskDetailOption" :data="taskDetailData">
        <template slot-scope="scope" slot="peText">
          {{scope.row.peText}}
        </template>
        <template slot-scope="scope" slot="markResult">
          <span>{{ $markResult.get(scope.row.markResult) }}</span>
        </template>

      </avue-crud>
    </el-drawer>

  </div>
</template>

<script>
import {taskTableOption, taskDetailOption} from '@/const/crud/dot/marking'
import {pageTask, detailTask} from '@/api/dot/marking'
import {rePushSingle} from '@/api/dot/order'
import {statistics} from '@/api/dot/flow'
import {formatDate} from '@/util/date'
import {mapGetters} from 'vuex';

export default {
  props: ['orderId', 'staParams'],
  data() {
    return {
      taskTableOption: taskTableOption,
      taskTableData: [],
      page: {
        pageSize: 20,
        pagerCount: 5
      },
      searchForm: {},
      taskDetailOption: taskDetailOption,
      taskDetailData: [],
      drawer: false,
      drawerStatus:0,
      drawerAmt: 0,
      drawerAddAmt: 0
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  mounted() {
    console.log(this.staParams);
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.page.currentPage = 1
      this.getPage(this.page, this.searchForm)
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
      this.getPage(this.page, this.searchForm)
    },
    formatDate(time) {
      if (time) {
        let date = new Date(parseFloat(time))
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
    },
    getPage: function (page, params) {
      pageTask(Object.assign({
        current: page.currentPage,
        size: page.pageSize
      }, params, {orderId: this.orderId})).then(response => {
        this.taskTableData = response.data.data.records
        this.page.total = response.data.data.total
      })
    },
    searchChange(params, done) {
      this.searchForm = params
      this.page.currentPage = 1
      this.getPage(this.page, this.searchForm)
      done();
      statistics(Object.assign({
        event_name: '搜索',
        event_type: 'click',
        class_name: 'pageTask',
        class_url: '/dotadmin/dotadmin/marking/task/page',
      }, this.staParams))
    },
    viewDetail(row, index) {
      this.drawer = true
      this.drawerAmt = row.amount;
      this.drawerStatus = row.status;
      this.drawerAddAmt = row.addAmount;
      detailTask(row.id).then(response => {
        this.taskDetailData = response.data.data;
        statistics(Object.assign({
          event_name: '查看详情',
          event_type: 'click',
          class_name: 'detailTask',
          class_url: '/dotadmin/dotadmin/marking/task/detail/',
          event_params: '{id: row.id}'
        }, this.staParams))
      })
    },
    handleClose() {
      this.drawer = false
    },
    refreshChange() {
      this.getPage(this.page)
    },
    rePushSingle(row) {
      //String orderId, Integer taskType, String packageNo
      rePushSingle({orderId: row.orderId, taskType: row.taskType, packageNo: row.packageNo}).then(res => {
        this.$message.success('推送结果：' + res.data.data);
        statistics(Object.assign({
          event_name: '重新推送',
          event_type: 'click',
          class_name: 'rePushSingle',
          class_url: '/dotadmin/dotadmin/order/rePushSingle',
          event_params: '{orderId: row.orderId, taskType: row.taskType, packageNo: row.packageNo}'
        }, this.staParams))
      })
    },
  },
}

</script>
<style lang="scss">
.el-drawer {
  overflow-y: auto;

  .note {
    font-size: 14px;
    padding-left: 20px;
    margin: 0 0 20px 0;
  }
}

</style>

<style scoped>
.item {
  margin-top: 10px;
}
</style>
